import { Component, Injector, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { IntegrationProvider } from '@modeso/aumico-lib-integrations-fe';
import { UntilDestroy } from '@ngneat/until-destroy';
import { BasePageComponent } from '../../../../pages/base.page';

@UntilDestroy()
@Component({
    selector: 'app-integrations',
    templateUrl: './integrations.page.html',
    styleUrls: ['./integrations.page.scss'],
})
export class IntegrationsPage extends BasePageComponent implements OnInit {
    public constructor(
        injector: Injector,
        dialog: MatDialog,
        private readonly integrationProvider: IntegrationProvider,
    ) {
        super(injector, dialog);
    }

    public override ngOnInit(): void {
        super.ngOnInit();
        this.integrationProvider.loadConnections();
    }

    /** login_hint for guided partner connects (§2 step 2) — a non-secret hint. */
    public get loginHint(): string | null {
        return this.auth.currentUser?.email ?? null;
    }
}
